export default "__VITE_ASSET__B$JGgsbJ__"